<template>
  <li class="pd__item">
    <div class="gutter">
      <div class="pd__head">
        <h2 class="pd__name">{{ item.name }}</h2>
        <p class="pd__desc">{{ item.desc }}</p>
        <p class="pd__price">${{ item.price }}</p>
      </div>
      <div class="pd__body">
        <div class="img__inner">
          <img
            class="img-resp"
            :src="item.src"
            :alt="item.name"
          >
        </div>
      </div>
      <div class="pd__foot">
        <ProdCounter />
      </div>
    </div>
  </li>
</template>

<script>
import ProdCounter from './ProdCounter';

export default {
  props: ['item'],
  components: {
    ProdCounter,
  },
}
</script>

<style>
.pd__item {
  padding: 10px;
}

.pd .gutter {
  height: 100%;
  padding: 15px;
  display: flex;
  flex-direction: column;
  border: solid 1px #ddd;
}

.pd__head, .pd__foot {
  text-align: center;
}

.pd__name {
  margin: 0;
}

.pd__price {
  margin: 0;
  font-size: 45px;
  font-weight: 600;
  color: #ff007c;
}
</style>



// WEBPACK FOOTER //
// src/components/Prod/ProdItem.vue